import React from 'react';
import { motion } from 'framer-motion';
import { Award, Target, Heart } from 'lucide-react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <Target size={32} />,
      title: 'Our Mission',
      description: 'To create unique and purposeful interiors that reflect our clients\' personalities and enhance their quality of life.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Our Vision',
      description: 'To be Kerala\'s most trusted interior design company, known for exceptional craftsmanship and customer satisfaction.'
    },
    {
      icon: <Award size={32} />,
      title: 'Our Values',
      description: 'Quality, integrity, innovation, and customer-centricity guide everything we do in our design process.'
    }
  ];

  const achievements = [
    { number: '500+', label: 'Projects Completed' },
    { number: '15+', label: 'Years Experience' },
    { number: '100%', label: 'Client Satisfaction' },
    { number: '50+', label: 'Expert Craftsmen' }
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="about-hero-content"
          >
            <h1 className="font-display">About JMJ Furniture & Interiors</h1>
            <p>
              Kerala's premier interior design company with over 15 years of experience
              in creating beautiful, functional spaces that inspire and delight.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-story">
            <div className="story-content">
              <h2 className="font-display">Our Story</h2>
              <p>
                Founded with a passion for creating beautiful spaces, JMJ Interior & Furniture
                has grown from a small local business to Kerala's most trusted interior design
                company. Based in Kottayam, we have been crafting some of the finest interior
                decoration projects across Kerala for over 15 years.
              </p>
              <p>
                Our journey began with a simple belief: every space has the potential to be
                extraordinary. Whether it's a cozy home in Munnar or a luxury hotel in Kochi,
                we bring the same level of dedication, creativity, and craftsmanship to every project.
              </p>
              <p>
                Today, we serve clients across Kottayam, Idukki, Pathanamthitta, Thiruvalla,
                Ernakulam, Kochi, and Alappuzha, creating spaces that are not just beautiful,
                but also functional and sustainable.
              </p>
            </div>
            <div className="story-image">
              <img src="/images/s1houseexterior.jpg" alt="JMJ Project" />
            </div>
          </div>
        </div>
      </section>

      <section className="section values-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Mission, Vision & Values</h2>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="value-card"
              >
                <div className="value-icon">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section achievements-section">
        <div className="container">
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="achievement-card"
              >
                <h3 className="font-display">{achievement.number}</h3>
                <p>{achievement.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;